import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import { LanguageContext } from "context/LanguageContext"
import { patchBasketItem } from "modules/basket/actions"
import { getCDNURL } from "network/api/networkSettings"
import { useContext, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

export const ClearCartPopUp = ({ open, onClose, product, itemsAddedToCart, clearPreOrder=false }) => {
    const { strings } = useContext(LanguageContext)
    const cartPatchInProgress = useSelector(state => state.basket.getIn(['cartPatchInProgress']))
    const dispatch = useDispatch()
    const [clearingCart, setClearingCart] = useState(false)
    const onClearCartContinueClick = (e) => {
        e.preventDefault()
        setClearingCart(true)
        if (clearPreOrder) {
            const preOrderItemsInCart = itemsAddedToCart?.filter(item => item?.platter_item_flag === '1')
            const items = removeProduct(preOrderItemsInCart)
            dispatch(patchBasketItem(items))
        }
        else {
            const items = removeProduct(itemsAddedToCart)
            items.push({
                product_id: product.product_id,
                count: 1,
                name: product.name,
                product_oos_option: product.product_oos_option || 'REMOVE',
                platter_item_flag: product?.platter_item_flag,
            })
            dispatch(patchBasketItem(items))
        }
    }

    const removeProduct = (cartItems) =>( 
        cartItems.map(item => ({
            product_id: item.product_id,
            count: 0,
            name: item.name,
            product_oos_option: item.product_oos_option || 'REMOVE',
            platter_item_flag: item?.platter_item_flag,
        }))
    )

    useEffect(()=>{
        if(clearingCart && !cartPatchInProgress){
            onClose()
        }
    },[clearingCart,cartPatchInProgress])

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                  onClose(event, reason)
                }
              }}
            maxWidth="xs"
            fullWidth
            disableEscapeKeyDown
            PaperProps={{ className: 'counter__dialog-paper' }}
            onClick={(e)=>e.preventDefault()}
        >

            {cartPatchInProgress ? <div className='counter__dialog-loader'><img
                className={'counter__dialog-loader-content'}
                src={getCDNURL() + 'assets/gifs/loader.gif'}
                alt={strings.loading}
            />
            </div> :
                <>
                    <DialogTitle className="counter__dialog-title">
                        {strings.platterWarningTitle}
                    </DialogTitle>
                    <DialogContent className="counter__dialog-content">
                        <DialogContentText className="counter__dialog-content-text">{product?.platter_item_flag === "1" ? strings.platterWarningContent2 : strings.platterWarningContent}</DialogContentText>
                    </DialogContent>
                    <DialogActions className="counter__dialog-action-btns">
                        <Button
                            onClick={onClose}
                            className="counter__dialog-button counter__dialog-button-cancel"
                        >
                            {strings.cancelBtn}
                        </Button>
                        <Button
                            className="counter__dialog-button counter__dialog-button-delete"
                            onClick={onClearCartContinueClick}
                        >
                            {strings.clearCartContinue}
                        </Button>
                    </DialogActions>
                </>
            }
        </Dialog>
    )
}
